const Style = () => ({
  wrapper: {
    display: 'flex',
    maxWidth: 'none',
    flexDirection: 'column',
  },

  content: {
    flexGrow: 1,
    margin: '0px auto !important',
  },
});

export default Style;
